<!--LIST NAVIGATION ITEMS-->
<!--NOTE: This list navigation is used as a table of contents with links that update the content page-->
<div class="list-items">
  <ul class="margin-top-small margin-bottom-small padding-bottom-small">
    <!--TODO: Refactor to use a common accordion with consistent expand and collapse functionality-->
    <li *ngFor="let menuItem of navItems; let i = index; trackBy: trackByNavigationItemId">
      <ng-container *ngIf="!menuItem.acf.parent_field; else parentField">
        <a
          *ngIf="menuItem.parent === 0"
          rel="noopener noreferrer nofollow"
          class="gen-neutral-black-link"
          [routerLink]="['/', slugname, menuItem.slug]"
          routerLinkActive="active-link"
          (click)="sendGoogleAnalytics('cms', 'click', menuItem.slug)"
          [ngClass]="{ 'active-link': menuItem.slug === slug }">
          {{ menuItem.title }}
        </a>
      </ng-container>
      <ng-template #parentField>
        <a
          class="cursor"
          (click)="toggleAccordion(i, menuItem.slug)"
          [ngClass]="{ 'active-link': menuItem.slug === slug }">
          {{ menuItem.title }}

          <i
            class="icon x-small red"
            [ngClass]="menuItem.isExpanded ? 'arrow-up' : 'arrow-down'"></i>
        </a>
      </ng-template>
      <!--NOTE: Show any child nav items if the children items have the same parent static page-->
      <ng-container *ngIf="childNavItems && childNavItems.length > 0">
        <ul
          *ngFor="let childItem of childNavItems"
          class="margin-left-large"
          [style.display]="checkAccordion(i, menuItem.slug) ? 'block' : 'none'">
          <li *ngIf="childItem && menuItem.id === childItem.parent">
            <a
              rel="noopener noreferrer nofollow"
              class="gen-neutral-black-link"
              [routerLink]="['/', slugname, childItem.slug]"
              routerLinkActive="active-link"
              (click)="sendGoogleAnalytics('cms', 'click', childItem.slug)"
              [ngClass]="{ 'active-link': childItem.slug === slug }"
              >{{ childItem.title }}</a
            >
          </li>
        </ul>
      </ng-container>
    </li>
  </ul>
</div>
<!--END LIST NAVIGATION ITEMS-->
